import createPersistedReducer from "use-persisted-reducer";
export const usePersistState = (state) => createPersistedReducer(state);
